import script from "./LpcoCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./LpcoCadastro.vue?vue&type=script&setup=true&lang=js"

import "./LpcoCadastro.vue?vue&type=style&index=0&id=a7577bfe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7577bfe"]])

export default __exports__